// src/stone/icons/FlipUp2.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var FlipUp2 = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M22.466 8H10.665a3.25 3.25 0 0 0-3.07 4.318l.945-.329-.945.329 1.61 4.628a2.5 2.5 0 0 0 2.361 1.679h11.309v-2H11.567a.5.5 0 0 1-.473-.336l-.944.329.944-.329-1.61-4.628A1.25 1.25 0 0 1 10.665 10h11.801z" }),
      /* @__PURE__ */ jsx("path", { d: "M12.218.127A11.875 11.875 0 0 0 .125 12v2.966a8.91 8.91 0 0 0 8.909 8.909h8.92a6.06 6.06 0 0 0 5.92-6.077v-5.794A11.794 11.794 0 0 0 12.219.127m-.015 1-.011 1a9.794 9.794 0 0 1 9.683 9.866v5.811a4.057 4.057 0 0 1-3.955 4.071H9.034a6.91 6.91 0 0 1-6.91-6.91V12a9.875 9.875 0 0 1 10.06-9.873z" })
    ]
  }
);
var FlipUp2_default = FlipUp2;

export {
  FlipUp2_default
};
